import moment from 'moment'
/**
 * 截取当前url指定参数
 * @export
 * @param {String} name // 参数名
 */
export function getQueryParam (name) {
  const url = window.location.href.split('?')
  const str = url[1]
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
  return str && str.match(reg) && str.match(reg).length >= 2 ? str.match(reg)[2] : null
}

/**
 * 截取当前url所有参数并以对象格式返回
 * @export
 */
export function getQueryAllParam () {
  const url = window.location.href.split('?')
  const str = url[1]
  const reg = new RegExp(/(\w+)=(\w+)/g)
  const obj = {}
  if (str) {
    str.match(reg).forEach((item) => {
      item.replace(reg, function (match, $1, $2) {
        obj[$1] = $2
      })
    })
  }
  return obj
}

/**
 * 深拷贝
 * @export
 */
export function deepCopy (source) {
  // 参数如果不是对象直接返回
  if (typeof source !== 'object' || source === null) { return source }
  // 参数如果为数组
  const newObj = Object.prototype.toString.call(source) === '[object Array]' ? [] : {}
  for (const key in source) {
    // 判断是自身属性，而非原型上的
    if (source.hasOwnProperty(key)) {
      newObj[key] = typeof source[key] === 'object' ? deepCopy(source[key]) : source[key]
    }
  }
  return newObj
}

/**
 * 获取前3月月份
 */
export function getMonths (date = new Date(), preCount = 3) {
  const months = []
  const currentDate = moment(date)
  for (let i = 0; i < preCount; i++) {
    months.push({
      year: currentDate.year(),
      month: currentDate.month() + 1,
      ymStr: `${currentDate.year()}-${currentDate.month() + 1}`
    })
    currentDate.subtract(1, 'months')
  }
  return months
}

/**
 * 获取页数
 */
export function getCountPages (total, perSize = 10) {
  if (isNaN(total) || isNaN(perSize)) {
    return 1
  }
  return Math.max(1, Math.ceil(total / perSize))
}
// 复制文本至粘贴板
export function copyText (text, successCallback, failCallback, notSupportCallback = failCallback) {
  if (typeof document.execCommand !== 'function' || typeof window.getSelection !== 'function') {
    notSupportCallback && notSupportCallback()
    return
  }
  const div = document.createElement('div')
  div.innerHTML = text
  div.setAttribute('style', 'position: absolute; height: 0;')
  document.body.appendChild(div)
  const selection = window.getSelection()
  if (selection.rangeCount > 0) {
    selection.removeAllRanges() // 清除当前页面中已有的selection
  }
  selection.selectAllChildren(div)
  // const range = document.createRange()
  // range.selectNode(div)// 执行选中元素
  // selection.addRange(range) // 选中需要复制的节点
  const result = document.execCommand('copy')
  document.body.removeChild(div)
  if (result) {
    successCallback && successCallback()
  } else {
    failCallback && failCallback()
  }
}
